"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as l } from "react";
import t from "../components/Icon/SvgIcon.js";
const a = (e) => /* @__PURE__ */ o(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.401 2h4.733a.4.4 0 0 1 .4.4v19.2a.4.4 0 0 1-.4.4H5.4a.4.4 0 0 1-.4-.4V2.4c0-.22.18-.4.401-.4m8.583 0h4.733a.4.4 0 0 1 .4.4v19.2a.4.4 0 0 1-.4.4h-4.733a.4.4 0 0 1-.401-.4V2.4c0-.22.18-.4.401-.4",
        clipRule: "evenodd"
      }
    )
  }
), n = l(a);
export {
  n as Pause,
  n as default
};
